import "./signup.css";
import Footer from "../small/Footer";
import { Icon } from "@iconify/react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { auth, app, firestoredb } from "../firebase";
import { useState } from "react";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
  FacebookAuthProvider,
  GoogleAuthProvider,
  updateProfile,
} from "firebase/auth";
import { toast } from "react-toastify";

const SignUp = () => {
  const [error, setError] = useState("");
  const [registeremail, setRegisterEmail] = useState("");
  const [registerpassword, setRegisterPassword] = useState("");
  const [userName, setRegisterName] = useState("");
  const [userRole, setRole] = useState("");

  const history = useNavigate();

  const register = async () => {
    try {
      const user = await createUserWithEmailAndPassword(
        auth,
        registeremail,
        registerpassword
      );
      // console.log();
      // updateProfile(currentUser, dAvatar);
      // console.log(currentUser.photoURL);
      // const db = getDatabase(app);

      // const postListRef = ref(db, "users");
      // const newPostRef = push(postListRef);
      // set(newPostRef, {
      //   email: registeremail,
      //   password: registerpassword,
      // });
      // console.log(user);
      const displayName = userName;

      updateProfile(user.user, { displayName });

      await setDoc(doc(firestoredb, "metamuze_Users", user.user.uid), {
        Name: userName,
        Email: user.user.email,
        Role: userRole,
      });
      history("/", { replace: true });
    } catch (error) {
      toast(error);
    }
  };
  return (
    <>
      <main className="create-own-bg">
        <section className="login">
          <div className="container">
            <h2 className="main-tite">Sign up</h2>
            <div className="name-wrap">
              <h3 className="craete-tit">Name</h3>
              <input
                className="create-input-txt mt-2"
                placeholder="Jhon Doe"
                type="text"
                onChange={(e) => setRegisterName(e.target.value)}
              />
            </div>
            <div className="email-wrap">
              <h3 className="craete-tit">Email address :</h3>
              <input
                className="create-input-txt mt-2"
                placeholder="someone@email.com"
                type="email"
                onChange={(e) => setRegisterEmail(e.target.value)}
              />
            </div>
            <div className="password-wrap">
              <h3 className="craete-tit">Password :</h3>
              <input
                className="create-input-txt mt-2"
                placeholder="Password"
                type="password"
                onChange={(e) => setRegisterPassword(e.target.value)}
              />
            </div>
            <div className="roler">
              <h3 className="craete-tit">Role :</h3>
              <select className="" onChange={(e) => setRole(e.target.value)}>
                <option disabled>Select Role</option>
                <option>Shop Owner</option>
                <option>Buyer</option>
              </select>
            </div>

            <div className="buttons-wrapper">
              <button className="login-btn" onClick={register}>
                Sign up
              </button>
              <Link className="sign-up-btn" to="/login">
                Login
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default SignUp;
